"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Mount = void 0;
const events_1 = __importDefault(require("events"));
const utils_1 = require("../../shared/utils");
const typings = __importStar(require("@monorepo/typings/sdk"));
const defaultTimeout = 10000;
class Mount extends events_1.default {
    isDetected;
    sdk;
    constructor(sdk) {
        super();
        this.sdk = sdk;
        this.loop(defaultTimeout);
    }
    loop = async (timeout) => new Promise(async (resolve, _reject) => {
        if (this.isDetected)
            resolve(true);
        let now = Date.now();
        switch (this.sdk.app) {
            case typings.Projects.titles.embark:
                while (true) {
                    if (typeof window !== 'undefined' && window.xrpl && window.xrpl.isEmbark) {
                        this.isDetected = window.xrpl.isEmbark;
                        window.embark = Object.assign({}, window?.embark, this.sdk);
                        this.emit('detected');
                        this.sdk.emit('detected');
                        resolve(true);
                        break;
                    }
                    await (0, utils_1.sleep)(500);
                    if (Date.now() > now + (timeout ?? defaultTimeout)) {
                        resolve(false);
                        break;
                    }
                }
                break;
            default:
                while (true) {
                    if (typeof window !== 'undefined' && window.xrpl && window.xrpl.isCrossmark) {
                        this.isDetected = window.xrpl.isCrossmark;
                        window.crossmark = Object.assign({}, window?.crossmark, this.sdk);
                        this.emit('detected');
                        this.sdk.emit('detected');
                        resolve(true);
                        break;
                    }
                    await (0, utils_1.sleep)(500);
                    if (Date.now() > now + (timeout ?? defaultTimeout)) {
                        resolve(false);
                        break;
                    }
                }
        }
    });
}
exports.Mount = Mount;
